module.exports = __webpack_public_path__ + "static/media/presidentsQuiz.0f17c7f7.png";